import React from 'react';
import { Grid } from '@material-ui/core';

import { FullScreenCard, Loading } from 'components';
import useShows from 'hooks/useShows';

import Creators from './components/Creators';
import { EditableLinksList } from './components/EditableLinksList';

const Links: React.FC = () => {
  const { selectedShow, loading: showsLoading } = useShows();
  const { itunesId } = selectedShow || {};

  if (showsLoading) {
    return (
      <FullScreenCard hideLogo size="mini" isNested>
        <Loading message="Loading..." />
      </FullScreenCard>
    );
  }

  return (
    <>
      <Grid item md={4} sm={12}>
        <EditableLinksList
          linkType="PLATFORM"
          title="Platforms"
          itunesId={itunesId}
          links={selectedShow.links}
        />
      </Grid>
      <Grid item md={4} sm={12}>
        <EditableLinksList
          linkType="EXTERNAL"
          title="External Links"
          itunesId={itunesId}
          links={selectedShow.links}
        />
      </Grid>
      <Grid item md={4} sm={12}>
        <Creators itunesId={itunesId} creators={selectedShow.creators || []} />
      </Grid>
    </>
  );
};

export default Links;
